module.exports = __webpack_public_path__ + "static/media/banesco-parking-selected.d6418fce.svg";